import React from 'react';
import { Button, Modal } from '../../../../Components/uielements';
import { ModalLabel } from '../user.style';
import {
  TwoColumns,
  ModalButtonWrapper,
  ModalWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { IntlMessages } from '../../../../helper/langHelper';

const CorporateAdminViewModal = ({ onClose, data }) => {
  return (
    <>
      <Modal isOpen={true} onClose={onClose} title="Member Details">
        <ModalWrapper>
          <>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.name" /> :
              </ModalLabel>
              <ModalLabel isCapitalize={true}>{data?.userName}</ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.email" /> :
              </ModalLabel>
              <ModalLabel>{data?.email}</ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.mobile.no" /> :
              </ModalLabel>
              <ModalLabel>
                {data?.countryCode} {data?.phone}
              </ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.company" /> :
              </ModalLabel>
              <ModalLabel>{data?.companyName}</ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.role" /> :
              </ModalLabel>
              <ModalLabel>{data?.role}</ModalLabel>
            </TwoColumns>
          </>
          <ModalButtonWrapper>
            <Button onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </Button>
          </ModalButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default CorporateAdminViewModal;
